import { FunctionComponent, memo } from "react";
import { IProps } from "./select-info-message.types";
import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons";
import styles from "./select-info-message.module.scss";
import { Icon } from "../../../icon";
import { Text } from "../../../text";

/**
 * Component for displaying a message in the select menu (will be displayed if the infoMessage callbackFn returns true)
 * @param props.message - The message to display
 * @returns {JSX.Element} - The SelectInfoMessage component
 */
const SelectInfoMessage: FunctionComponent<IProps> = ({ message }) => {
    return (
        <div className={styles["container"]}>
            <div className={styles["content"]}>
                <Icon className={styles["icon"]} icon={faInfoCircle} size="sm" />
                <Text size="sm">{message}</Text>
            </div>
        </div>
    );
};

export default memo(SelectInfoMessage);
